var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c("div", { staticClass: "row q-mb-sm" }, [
        _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
          _c(
            "div",
            { staticClass: "q-display-1 text-secondary" },
            [
              _c("q-icon", {
                staticClass: "q-mb-sm",
                attrs: { name: "fas fa-list" }
              }),
              _vm._v(" " + _vm._s(_vm.$t(_vm.title_live_class)) + "\n\t\t\t")
            ],
            1
          )
        ])
      ]),
      _c(
        "q-tabs",
        {
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "basic-data",
              label: _vm.$t("basic_data")
            },
            slot: "title"
          }),
          _c("q-tab", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showTab && _vm.guestType,
                expression: "showTab && guestType"
              }
            ],
            attrs: { slot: "title", name: "guests", label: _vm.$t("guests") },
            slot: "title"
          }),
          _c("q-tab", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showTab && !_vm.guestType,
                expression: "showTab && !guestType"
              }
            ],
            attrs: {
              slot: "title",
              name: "subscribers",
              label: _vm.$t("subscribers")
            },
            slot: "title"
          }),
          _c("q-tab", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showTab,
                expression: "showTab"
              }
            ],
            attrs: { slot: "title", name: "tests", label: _vm.$t("tests") },
            slot: "title"
          }),
          _c("q-tab", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showTab,
                expression: "showTab"
              }
            ],
            attrs: {
              slot: "title",
              name: "support_material",
              label: _vm.$t("support_materials")
            },
            slot: "title"
          }),
          _c("q-tab", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showTab,
                expression: "showTab"
              }
            ],
            attrs: {
              slot: "title",
              name: "reaction_tests",
              label: _vm.$t("reaction_tests")
            },
            slot: "title"
          }),
          _c("q-tab", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showTab,
                expression: "showTab"
              }
            ],
            attrs: {
              slot: "title",
              name: "live-class",
              label: _vm.$t("live_class")
            },
            slot: "title"
          }),
          _vm.useReviews
            ? _c("q-tab", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showTab,
                    expression: "showTab"
                  }
                ],
                attrs: {
                  slot: "title",
                  name: "comments",
                  label: _vm.$t("comments")
                },
                slot: "title"
              })
            : _vm._e(),
          _c(
            "q-tab-pane",
            { attrs: { name: "basic-data" } },
            [
              _c("basic-data", {
                attrs: {
                  manageLiveClasses: _vm.permissions.live_classes_manage
                },
                on: { updateClassData: _vm.updateClassData }
              })
            ],
            1
          ),
          _c(
            "q-tab-pane",
            { attrs: { name: "guests" } },
            [
              _c("guests", {
                attrs: {
                  allowed_guest_areas: _vm.allowed_guest_areas,
                  allowed_guest_profiles: _vm.allowed_guest_profiles,
                  guest_limit: _vm.live_class_guest_limit,
                  manageLiveClasses: _vm.permissions.live_classes_manage
                }
              })
            ],
            1
          ),
          _c(
            "q-tab-pane",
            { attrs: { name: "subscribers" } },
            [
              _c("subscribers", {
                attrs: {
                  manageLiveClasses: _vm.permissions.live_classes_manage
                }
              })
            ],
            1
          ),
          _c(
            "q-tab-pane",
            { attrs: { name: "tests" } },
            [
              _c("tests", {
                attrs: {
                  manageLiveClasses: _vm.permissions.live_classes_manage
                }
              })
            ],
            1
          ),
          _c(
            "q-tab-pane",
            { attrs: { name: "support_material" } },
            [
              _c("support-material", {
                attrs: {
                  manageLiveClasses: _vm.permissions.live_classes_manage
                }
              })
            ],
            1
          ),
          _c(
            "q-tab-pane",
            { attrs: { name: "reaction_tests" } },
            [
              _c("reaction-tests", {
                attrs: {
                  manageLiveClasses: _vm.permissions.live_classes_manage
                }
              })
            ],
            1
          ),
          _c(
            "q-tab-pane",
            { attrs: { name: "live-class" } },
            [
              _c("live-class", {
                attrs: {
                  platform_type: _vm.platform_type,
                  embed: _vm.embed,
                  title: _vm.live_class_title,
                  description: _vm.live_class_description,
                  room: _vm.live_class_room,
                  date_class: _vm.date_class,
                  timezone: _vm.timezone,
                  status: _vm.status
                }
              })
            ],
            1
          ),
          _c(
            "q-tab-pane",
            { attrs: { name: "comments" } },
            [_c("comments", { attrs: { origin: "live_class" } })],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }